import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { timerComponent } from "../cheque-book-request/timerComponent";
import { Component, OnInit } from '@angular/core';
import { Angular2CsvModule } from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
@Component({
  selector: 'app-td-account',
  templateUrl: './td-account.component.html',
  styleUrls: ['./td-account.component.css'],
   providers: [
{ provide: 'Window', useValue: window }
]
})
export class TdAccountComponent implements OnInit {
  message: string;
  linkedAccounts: any;
  tdacctNo: any;
  tdAccounts: any =[];

  isHaveTDAccount: string = '';
  isHaveLoanAccount: string = '';
   transactionListTD: any;
  tdDetails: any;
   isShow: string = 'page1';
  accountNoTD: string;
  isTrueTD: string = 'hide';
  accountInfoTD: any;
  moduleType : string ='';
  fullName : string ='' ;
  clrBalanceStr : string ='';
  recieptsNo: any;
  recieptsNo1: string;
  showTDAllTransaction: string='';
  showTDAcctBalance: string = '';
  showTDAcctBalanceButtonName: string ='';
  showTDAllTransactionButtonName: string ='';
  TotalIntOrPrincAmt:any=0;
  TdAccNo:any;
  constructor(private webService: CallBackEndService,
    private timetStart : timerComponent

  ) {
  this.tdAccounts = JSON.parse(sessionStorage.getItem('tdAccounts'));
  this.tdDetails = JSON.parse(sessionStorage.getItem('tdDetails'));
    this.linkedAccounts = JSON.parse(sessionStorage.getItem('linkedAccounts'));
    this.isHaveLoanAccount =sessionStorage.getItem('isHaveLoanAccount');
	this.isHaveTDAccount =sessionStorage.getItem('isHaveTDAccount');
	
    const request: IbRequest = new IbRequest();
      const response: IbResponse = null;
	this.accountNoTD=this.tdAccounts[0];
	/* for(const [key, value] of Object.entries(this.tdAccounts))
	 {
		 let AccountNo=value;
console.log("Account No--"+AccountNo)
		  for(const [key1, value1] of Object.entries(this.tdDetails))
		  {
			  console.log("key1--"+key1+"value1---"+ JSON.stringify(value1))
			  for(const [key2, value2] of Object.entries(value1))
			  {
			   console.log("value2--"+value2);
			if(key2==="prdAcctId")
			{
			  if(value2===AccountNo){
				 console.log("value2--"+value2)
				
				this.TotalIntOrPrincAmt=this.TotalIntOrPrincAmt+parseFloat(value2+"");
				console.log("this.TotalIntOrPrincAmt--"+this.TotalIntOrPrincAmt)
			  }
			}
		}
			
		  }
	 }*/
  //  alert("tdaccount"+this.accountNoTD);
  console.log('td account iss ' + this.accountNoTD);
  request.param1 = getHexAscii('', this.accountNoTD);
    request.param2 = this.accountNoTD;
  // this.isTrueTD='hide';
    if(this.accountNoTD === undefined ){
      this.isShow='RecordNotFound';
    this.message="Record Not Found";
    }
    else{

  this.showTDAcctBalance='hide';
        this.showTDAllTransaction='hide';
	for(const [key1, value1] of Object.entries(this.linkedAccounts))
		  {
			   console.log("key11--"+key1+"value11---"+ JSON.stringify(value1.moduleType))
			   if(value1.moduleType==="Deposits")
			   {
				 console.log("value1.accountNo151=--"+value1.accountNo15)   
				if(value1.accountNo15===this.accountNoTD)
				    this.clrBalanceStr =value1.TDBalance;
			   }
		  
		  }	
		 this.isTrueTD='show'; 
  this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      console.log("status isss "+data.status + 'param 8 isss '+data.param8);
    this.showTDAcctBalance='hide';
        this.showTDAllTransaction='hide';
       if (data.status === 'S101') {
        alert('Malicious Request Detected');
       // $state.go('login');
      }
        if (data !== null && data.status === 'S200') {
          //this.transactionListRespTD=IbResponse;
          this.showTDAllTransaction='hide';
          console.log("come here");
          
          this.accountInfoTD=data.param5;
          this.moduleType = data.param5.moduleType;
          this.fullName = data.param5.fullName;
          //this.clrBalanceStr = data.param5.clrBalanceStr;
        this.transactionListTD=data.param8;
        this.recieptsNo=this.transactionListTD.recieptNo;
          this.isShow='page2';
          console.log("data isss "+data);
          //this.isTrueTD='show';
         // this.timetStart.resetTimer();
        }
   
    if (data === null && data.status === 'OBJECT_NOT_FOUND') {
        console.log('dcfd ' +data.status);
       this.isShow='RecordNotFound';
       this.message="Record Not Found";
     }
    this.isTrueTD='show';
      });
   }

  }
  ngOnInit() {
   
  }
showTransactionTD() {
	 for(const [key1, value1] of Object.entries(this.linkedAccounts))
		  {
			   console.log("key1--"+key1+"value1---"+ JSON.stringify(value1.moduleType))
			   if(value1.moduleType==="Deposits")
			   {
				 console.log("value1.accountNo15=--"+value1.accountNo15)   
				if(value1.accountNo15===this.accountNoTD)
				    this.clrBalanceStr =value1.TDBalance;
			   }
		  
		  }
		   this.isTrueTD='show';
   const request: IbRequest = new IbRequest();
      const response: IbResponse = null;
  console.log("td account iss "+this.accountNoTD);
  request.param1 = getHexAscii('', this.accountNoTD);
    request.param2 = this.accountNoTD;
  //this.isTrueTD='hide';
  this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      console.log("status isss "+data.status+"param 8 isss "+data.param8);
    this.showTDAcctBalance='hide';
        this.showTDAllTransaction='hide';
       if (data.status === 'S101') {
        alert('Malicious Request Detected');
       // $state.go('login');
      }
        if (data !== null && data.status === 'S200') {
          //this.transactionListRespTD=IbResponse;
          this.showTDAllTransaction='hide';
          console.log("come here");
          
          this.accountInfoTD=data.param5;
        this.transactionListTD=data.param8;
         // this.clrBalanceStr = data.param5.clrBalanceStr;
        this.recieptsNo=this.transactionListTD.recieptNo;
          this.isShow='page2';
          console.log("data isss "+data);
          //this.isTrueTD='show';
        } 
    this.isTrueTD='show';
      });
}
  showTDBalance() {
      if(this.showTDAcctBalance==='hide') {
        this.showTDAcctBalance='show';
        this.showTDAcctBalanceButtonName='Hide';
      } else {
        this.showTDAcctBalance='hide';
        this.showTDAcctBalanceButtonName='Show';
      
  }
  }
  showTDMiniTransaction() {
      if(this.showTDAllTransaction==='hide') {
        this.showTDAllTransaction='show';
        this.showTDAllTransactionButtonName='Hide';
      } else {
        this.showTDAllTransaction='hide';
        this.showTDAllTransactionButtonName='Show';
      }
  }
  
   
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/td-account/td-account.component.ts